class RouterService {
  navigate(path) {
    window.location.href = path; 
  }
}

export default RouterService;
